<template>
  <v-breadcrumbs
    :items="items"
    :large="large"
    :divider="divider"
    class="no-print pl-0"
  >
    <template v-if="customDiv" v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    divider: "/",
    dividers: ["/", "\\", ".", ";", ">", "-"],
    large: true,
    customDiv: false
  })
};
</script>

<style lang="scss">
.v-breadcrumbs {
  padding: 6px 12px;
}
.v-breadcrumbs li:nth-child(even) {
  padding: 0 6px;
}

.v-breadcrumbs--large li {
  font-size: 14px;
}
</style>
